import moment from 'moment';

export const RANGE_PRESETS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last7', label: 'Last 7 days' },
  { value: 'last30', label: 'Last 30 days' },
  { value: 'thisMonth', label: 'This month' },
  { value: 'lastMonth', label: 'Last month' },
  { value: 'thisYear', label: 'This year' },
  { value: 'custom', label: 'Custom range' },
];

function bounds(preset, custom, now) {
  const today = now.clone().startOf('day');
  switch (preset) {
    case 'yesterday': return [today.clone().subtract(1, 'day'), today.clone().subtract(1, 'day')];
    case 'last7': return [today.clone().subtract(6, 'days'), today];
    case 'last30': return [today.clone().subtract(29, 'days'), today];
    case 'thisMonth': return [today.clone().startOf('month'), today];
    case 'lastMonth': return [today.clone().subtract(1, 'month').startOf('month'), today.clone().subtract(1, 'month').endOf('month').startOf('day')];
    case 'thisYear': return [today.clone().startOf('year'), today];
    case 'custom': return [moment(custom.startDate).startOf('day'), moment(custom.endDate).startOf('day')];
    default: return [today, today];
  }
}

export function buildRange(preset, custom, now = moment(new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()), 'YYYY-MM-DD')) {
  const [from, to] = bounds(preset, custom || {}, now);
  const diffDays = Math.abs(to.diff(from, 'days'));
  const label = from.isSame(to, 'day') ? from.format('MMM D, YYYY') : `${from.format('MMM D, YYYY')} – ${to.format('MMM D, YYYY')}`;
  return {
    from, to,
    fromDate: from.format('MM/DD/YYYY'),
    toDate: to.format('MM/DD/YYYY'),
    diffDays,
    range: JSON.stringify({ startDate: from.format('YYYY-MM-DD'), endDate: to.format('YYYY-MM-DD') }),
    label,
  };
}
